const state = {
  qrCodes: [],
  confidenceGrades: [],
  isLoading: false,
  error: null,
};

export default state;
